import {
  VaultAccountPayoutFrequencySetAuditEntry,
  VaultCreateKybKycSubmitAuditEntry,
  VaultOrgConfirmationSubmitAuditEntry,
  VaultStripeConnectAccountPaymentMethodDefaultSetAuditEntry,
} from '../../components/AuditLogs/types';
import { vaultRequest } from './request';

const getLogs = async <T>(orgId: string, query: string): Promise<T[]> => {
  const auditLogRes = await vaultRequest(query, {
    orgId,
  });
  const auditLogData = await auditLogRes.json();
  if (auditLogData.errors) {
    throw new Error(JSON.stringify(auditLogData.errors));
  }
  return auditLogData.data.auditLogs;
};

const GET_CREATE_KYB_KYC_LOGS = `
query VaultCreateKybKycSubmitAuditEntries($orgId: ID) {
  auditLogs: vaultCreateKybKycSubmitAuditEntries(orgId: $orgId) {
    id
    created
    userId
    orgId
    saveToPayableOrgId
    stripeEnv
    statementDescriptor
    stripeMetadataEntity
    stripeMetadataActivityType
    stripeMetadataFundraiserId
    stripeMetadataPaymentType
    stripeMetadataTransactionId
    stripeMetadataFundraiserIdLegacy
    kybId
    kybRaiseFundraiserId
    kybLegalName
    kybCustomerFacingName
    kybDescription
    kybUrl
    kybPhoneNumber
    kybEmail
    kybTaxId
    kybAddressStreet
    kybAddressUnit
    kybAddressCity
    kybAddressRegion
    kybAddressPostalCode
    kybType
    kybStructure
    representativeKycId
    representativeStripePersonId
    representativeFirstName
    representativeLastName
    representativePhoneNumber
    representativeEmail
    representativeSsn
    representativeDobDay
    representativeDobMonth
    representativeDobYear
    representativeAddressStreet
    representativeAddressUnit
    representativeAddressCity
    representativeAddressRegion
    representativeAddressPostalCode
    representativePercentOwnership
    representativeTitle
    representativeDirector
    representativeExecutive
    representativeRepresentative
    representativeOwner
    accountId
    financialAccountNodeId
    createStripeConnectAccountResponse
    createStripeRepresentativeResponse
    ownersProvidedResponse
    createStripeConnectAccountPayableOrgResponse
    createStripeRepresentativePayableOrgResponse
    ownersProvidedPayableOrgResponse
  }
}
`;

export const getCreateKybKycLogs = async (
  orgId: string,
): Promise<VaultCreateKybKycSubmitAuditEntry[]> =>
  getLogs<VaultCreateKybKycSubmitAuditEntry>(orgId, GET_CREATE_KYB_KYC_LOGS);

const GET_ORG_CONFIRMATION_LOGS = `
query VaultOrgConfirmationSubmitAuditEntries($orgId: ID) {
  auditLogs: vaultOrgConfirmationSubmitAuditEntries(orgId: $orgId) {
    id
    created
    userId
    orgId
    saveToPayableOrgId
    submittedOnYourBehalf
    kybId
    accountId
    financialAccountNodeId
    stripeEnv
    statementDescriptor
    stripeMetadataEntity
    stripeMetadataActivityType
    stripeMetadataFundraiserId
    stripeMetadataPaymentType
    stripeMetadataTransactionId
    stripeMetadataFundraiserIdLegacy
    representativeKycId
    representativeUserId
    representativeStripePersonId
    representativeFirstName
    representativeLastName
    representativePhoneNumber
    representativeEmail
    representativeSsn
    representativeDobDay
    representativeDobMonth
    representativeDobYear
    representativeAddressStreet
    representativeAddressUnit
    representativeAddressCity
    representativeAddressRegion
    representativeAddressPostalCode
    representativePercentOwnership
    representativeTitle
    representativeDirector
    representativeExecutive
    representativeRepresentative
    representativeOwner
    representativeToReplaceKycId
    representativeToReplaceUserId
    representativeToReplaceStripePersonId
    updateStatementDescriptorResponse
    replaceWorkflowDeleteStripePersonResponse
    replaceWorkflowCreateStripeRepresentativeResponse
    submittedOnYourBehalfCreateStripeConnectAccountResponse
    submittedOnYourBehalfCreateStripeRepresentativeResponse
    updateStatementDescriptorResponse
  }
}`;

export const getOrgConfirmationLogs = async (
  orgId: string,
): Promise<VaultOrgConfirmationSubmitAuditEntry[]> =>
  getLogs<VaultOrgConfirmationSubmitAuditEntry>(
    orgId,
    GET_ORG_CONFIRMATION_LOGS,
  );

const GET_PAYMENT_METHOD_DEFAULT_SET_LOGS = `
query VaultStripeConnectAccountPaymentMethodDefaultSetAuditEntries($orgId: ID) {
  auditLogs: vaultStripeConnectAccountPaymentMethodDefaultSetAuditEntries(orgId: $orgId) {
    createTokenResponse
    created
    id
    orgId
    updateAccountResponse
    userId
  }
}`;

export const getPaymentMethodDefaultSetLogs = async (
  orgId: string,
): Promise<VaultStripeConnectAccountPaymentMethodDefaultSetAuditEntry[]> =>
  getLogs<VaultStripeConnectAccountPaymentMethodDefaultSetAuditEntry>(
    orgId,
    GET_PAYMENT_METHOD_DEFAULT_SET_LOGS,
  );

const GET_PAYOUT_FREQUENCY_SET_LOGS = `
query VaultAccountPayoutFrequencySetAuditEntries($orgId: ID) {
  auditLogs: vaultAccountPayoutFrequencySetAuditEntries(orgId: $orgId) {
    created
    id
    orgId
    updateAccountResponse
    userId
  }
}`;

export const getPayoutFrequencySetLogs = async (
  orgId: string,
): Promise<VaultAccountPayoutFrequencySetAuditEntry[]> =>
  getLogs<VaultAccountPayoutFrequencySetAuditEntry>(
    orgId,
    GET_PAYOUT_FREQUENCY_SET_LOGS,
  );
